import React, { Component } from 'react';
import {
  Button,
  Container,
  CssBaseline,
  Divider,
  Typography,
} from '@material-ui/core';
import { NavLink } from 'react-router-dom';

import image from '../../BS_FOOD_logo.png';
import { retrieveToken } from '../../utils/storage.js';
import { withStyles } from '@material-ui/styles';

const styleToUse = (theme) => ({
  container: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  title: {
    // fontWeight: 600,
    textAlign: 'center',
    padding: '20px',
    color: theme.palette.primary.main,
  },
  message: {
    padding: '10px',
    color: theme.palette.primary.main,
  },
  divider: {
    width: 72,
    height: 3,
    margin: '0 auto 40px',
    borderRadius: 4,
    background: theme.palette.primary.main,
  },
  ctaButton: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 8,
    border: 0,
    color: theme.palette.text.main,
    height: 48,
    minWidth: 240,
    padding: '0 30px',

    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.text.main,
    },
  },
});

class HomePage extends Component {
  constructor() {
    super();
    this.state = {
      isAuthenticated: false,
      message: 'Effettua il login per gestire la piattaforma',
      img: image,
      titleImg: 'BS_FOOD_logo',
    };
  }

  componentDidMount() {
    const token = retrieveToken();
    if (token !== null) {
      this.setState({
        isAuthenticated: true,
        message: 'Clicca sul pulsante per procedere',
      });
    } else {
      this.setState({
        isAuthenticated: false,
        message: 'Effettua il login per gestire la piattaforma',
      });
    }
  }

  render() {
    const { classes } = this.props;

    let accessButton = this.state.isAuthenticated ? (
      <NavLink
        to="/amministrazione/responsabili_sicurezza"
        style={{ textDecoration: 'none' }}
      >
        <Button variant="contained" className={classes.ctaButton}>
          Pannello Controllo
        </Button>
      </NavLink>
    ) : (
      <NavLink to={'/login'} style={{ textDecoration: 'none' }}>
        <Button variant="contained" className={classes.ctaButton}>
          Login
        </Button>
      </NavLink>
    );

    let msg = this.state.message;

    return (
      <React.Fragment>
        <CssBaseline />

        <Container id="home_container" maxWidth="lg">
          <div className={classes.container}>
            <div
              style={{
                padding: '10px 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" className={classes.title}>
                Pannello di controllo di {this.props.theme.nomeBrand}
              </Typography>
              <Divider className={classes.divider} />
              <img
                src={
                  this.props.theme.logo.url !== undefined
                    ? this.props.theme.logo.url
                    : this.state.img
                }
                alt={this.state.titleImg}
                style={{
                  width: 270,
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <div
              style={{
                margin: '20px 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6" className={classes.message}>
                {msg}
              </Typography>
              <div style={{ marginTop: '30px' }}>{accessButton}</div>
            </div>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}
export default withStyles(styleToUse, { withTheme: true })(HomePage);
